import { createSlice } from '@reduxjs/toolkit';
import {
  getCaseBillForPaymentMethod,
  getCountInvoice,
  getCountInvoicePreMonth,
  getUserInfo,
  getStatusBill,
} from 'pages/Dashboard/thunks';
import { getWorkspace } from 'pages/LoginPage/thunk';

interface InitialState {
  currentWorkSpaceId?: string;
  currentApplicationId?: string;
  userInfo?: any;
  countBillFirst?: number;
  countBillPre?: number;
  caseRight?: any;
  statusBill?: {
    i_id?: string;
    value: string;
  };
  loadingStatusBill: boolean;
}

const initialState: InitialState = {
  loadingStatusBill: false,
};

const workSpacesSlice = createSlice({
  name: 'workSpaces',
  initialState,
  reducers: {
    resetUser(state) {
      return {
        userInfo: null,
        countBillFirst: 0,
        countBillPre: 0,
        caseRight: null,
        loadingStatusBill: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStatusBill.pending, (state) => ({ ...state, loadingStatusBill: true }));

    builder.addCase(getWorkspace.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
    builder.addCase(getUserInfo.fulfilled, (state, action) => ({ ...state, userInfo: action.payload }));
    builder.addCase(getCountInvoice.fulfilled, (state, action) => ({ ...state, countBillFirst: action.payload }));
    builder.addCase(getCountInvoicePreMonth.fulfilled, (state, action) => ({ ...state, countBillPre: action.payload }));
    builder.addCase(getStatusBill.fulfilled, (state, action) => ({
      ...state,
      loadingStatusBill: false,
      statusBill: {
        i_id: action.payload.items[0]?.i_id,
        value: action.payload.items[0]?.value || '---',
      },
    }));
    builder.addCase(getCaseBillForPaymentMethod.fulfilled, (state, action) => ({
      ...state,
      caseRight: action.payload,
    }));

    builder.addCase(getStatusBill.rejected, (state) => ({
      ...state,
      loadingStatusBill: false,
      statusBill: {
        value: '---',
      },
    }));
  },
});

export const { resetUser } = workSpacesSlice.actions;
export default workSpacesSlice.reducer;
